import { View as AnimatableView } from 'react-native-animatable';
import DropShadow from 'react-native-drop-shadow';
import styled, { css } from 'styled-components/native';

import IconNewLike from '../../../assets/svg/IconNewLike';
import { lightBrown } from '../../../constants/color';
import { useTranslation } from '../../../i18n';
import { makeDataByIdKey } from '../../../redux/selectors/vendorDetailSelector';
import { useSelector } from '../../../redux/utils';
import CollectBtn from './CollectBtn';

type Props = {
  isDown: boolean;
  id: string;
};

const NotiBarContext = ({ isDown, id }: Props) => {
  const isLoved = useSelector(makeDataByIdKey(id, 'is_loved'));
  const { t } = useTranslation();

  if (!isDown || isLoved) {
    return null;
  }

  const BtnContent = () => {
    return (
      <S.CollectBtnContainer>
        <IconNewLike size={16} fillColor={lightBrown} />
        <S.CollectBtnText>
          {t('vendor-page-notification-bar.button-text')}
        </S.CollectBtnText>
      </S.CollectBtnContainer>
    );
  };

  return (
    <S.Animatable animation="slideInDown" duration={500}>
      <S.DropShadow>
        <S.Container>
          <S.Context>
            <S.BoldText>
              {t('vendor-page-notification-bar.context1')}
            </S.BoldText>
            <S.Text>{t('vendor-page-notification-bar.context2')}</S.Text>
          </S.Context>
          <CollectBtn BtnContent={BtnContent} id={id} />
        </S.Container>
      </S.DropShadow>
    </S.Animatable>
  );
};

export default NotiBarContext;

const textStyle = css`
  font-size: 15px;
  line-height: 22px;
  color: ${({ theme }) => theme.palette.lightBrown};
`;
const S = {
  Animatable: styled(AnimatableView)`
    position: absolute;
    top: 0;
    width: 100%;
  `,
  DropShadow: styled(DropShadow)`
    shadow-color: ${({ theme }) => theme.palette.black};
    shadow-opacity: 0.2;
    shadow-radius: 10px;
    shadow-offset: 0 2px;
    elevation: 10px;
  `,
  Container: styled.View`
    background-color: #fbf2e8;
    padding: 15px;
    padding-left: 20px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,
  Context: styled.View`
    flex-direction: column;
    flex: 1;
  `,
  Text: styled.Text`
    ${textStyle};
  `,
  BoldText: styled.Text`
    ${textStyle};
    font-weight: bold;
  `,
  CollectBtnContainer: styled.View`
    flex-direction: row;
    align-items: center;
    padding: 5px 8px;
    background-color: ${({ theme }) => theme.palette.lightOrange};
    border-radius: 14px;
  `,
  CollectBtnText: styled.Text`
    font-size: 13px;
    font-weight: bold;
    line-height: 18px;
    margin-left: 4px;
    color: ${({ theme }) => theme.palette.lightBrown};
  `,
};
